<template>
  <div style="zoom:1.2">
    <!--    
<div style="position:absolute; top:0px; left:0px">
      {{annotation()}}
</div>
-->
    <div
      ref="annot8-toolbar-container"
      class="annot8-toolbar-container"
      :style="style().container"
    >
      <!-- <transition-group name="fade"> -->
      <div
        v-if="lastAnnotation && currentMenu === 'comments'"
        class="annot8-modal-inner"
        :class="modalClass"
        style="margin:auto"
        key="modal"
      >
      
        <div class="annot8-modal-body">
          <textarea
            v-model="commentEdit"
            v-if="edit"
            class="annot8-textarea"
            rows="4"
            placeholder="Write notes..."
          ></textarea>
          <button
            key="save"
            v-if="edit"
            class="annot8-modal-button"
            style="float:right"
            @click="saveComment"
          >
            <svg viewBox="0 0 1550 1188" witdh="12" height="12">
              <path
                d="M1550 232q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136L28 662Q0 634 0 594t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
              />
            </svg>
          </button>

          <div
            key="comment"
            v-if="!edit"
            class="annot8-modal-text"
          >
            {{ comment }}
          </div>

          <button
            key="edit"
            v-if="!edit"
            class="annot8-modal-button"
            style="float:right"
            @click="edit = !edit"
          >
            <svg viewBox="0 0 1515 1515" witdh="12" height="12">
              <path
                d="M363 1387l91-91-235-235-91 
          91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7L305 986q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832H0v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"
              />
            </svg>
          </button>
        </div>
      </div>
      <!-- </transition-group> -->

      <div class="annot8-ui annot8-toolbar" :style="style().toolbar">
        <div v-if="currentButtons" ref="annot8-toolbar-inner" :class="$store.state.user.user.subscription.status == 'active' ? `annot8-ui annot8-toolbar-inner premium` : `annot8-ui annot8-toolbar-inner`">
          <!-- <transition-group name="fade"> -->
          <button
            v-for="(btn, idx) in currentButtons"
            :key="'btn' + idx"
            class="annot8-toolbar-button annot8-disableSelection"
            :data-tag="btn.title == 'Highlight' ? state.tag : btn.tag"
            :class="extraClass(btn)"
            @click="onAction(btn)"
          >
            <span class="annot8-toolbar-icon" v-html="icon(btn)"></span>
            <!-- <span v-if="!$config.mobile && btn.label" class="annot8-toolbar-label">{{btn.label}}</span> -->
            <span class="annot8-toolbar-label">{{btn.label}}</span>
          </button>
          <!-- </transition-group> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Icons from "./icons.js";
import Buttons from "./buttons";
import buttons from './buttons';

export default {
  data() {
    return {
      timeoutId: 0,
      isMobile: false,
      edit: false,
      commentEdit: "",
      lastAnnotation: null,
      lastSelectionBounds: null,
      toolbarRect: { ready: false },
      mobile: false
    };
  },

  props: {
    state: Object
  },

  watch: {
    "state.focus": function(n) {
      this.annotation();
    }
  },

  computed: {
    comment() {
      var annot = this.api().annotation();
      if (annot) {
        return annot.comment;
      }
      return null;
    },

    currentMenu() {
      return this.state.subMenu || this.state.menu;
    },

    currentButtons() {

      if (this.currentMenu === "edit" && this.state.focus === null) {
        return [];
      }
      
      //if web
      if(!this.mobile && this.currentMenu !== null) {
          //if law
        if(this.$route.name == "lawPage" && this.currentMenu) {
           return Buttons.law.web[this.currentMenu];
        }

         return Buttons.web[this.currentMenu];
      }

      //if law
      if(this.$route.name == "lawPage" && this.currentMenu) {
        return Buttons.law.mobile[this.currentMenu];
      }

      return Buttons.mobile[this.currentMenu];
    },

    modalClass() {
      // return [ ".annot8-hl", "annot8-hl-tag2" ]
      return null;
    }
  },

  methods: {
    icon(btn) {
      // return '<div style="display:block">' + Icons[btn.icon.replace("#", "")]
      //    + (btn.label ? '<div class="annot8-btn-label">' + btn.label + '</div>' : '')
      //    + '</div>';
      return Icons[btn.icon.replace("#", "")];
    },

    extraClass(btn) {},

    onAction(btn, action) {
      if (!action) {
        action = btn.action;
      }
      let params = {
        tag: btn.tag || this.api().tag,
        tagid: btn.tagid
      };

      if (this.annotation()) {
        params.id = this.annotation().id;
      }

      // this.api().debugLog(params);

      switch (action) {
        case "annotate":
          this.api().annotate(params);
          break;
        case "tags":
          this.api().requestMenu("tags");
          break;
        case "comment": {
          if (!this.annotation()) {
            return;
          }
          this.edit = !this.annotation().comment;
          this.api().requestMenu("comments");
          break;
        }
        case "erase":
          this.api().erase(params.id);
          break;
        case "copy":
          this.api().copyText();
          break;
        case "notebook":
          this.api().addToNotebook();
          break;
        case "help":
          this.api().setState({ menu: null, subMenu: null });
          this.api().$parent.help();
          break;
      }
    },

    saveComment() {
      var comment = this.commentEdit; // grab this first
      this.edit = false;
      if (this.annotation()) {
        this.api().comment({
          id: this.annotation().id,
          comment: comment.replace(/[^\x20-\x7E]/g, "")
        });
      }
    },

    api() {
      return this.$parent;
    },

    annotation() {
      this.lastAnnotation =
        this.api().annotation() || this.lastAnnotation || {};
      this.commentEdit = this.lastAnnotation.comment;
      return this.lastAnnotation;
    },

    style() {
      this.compute();
      let bounds = this.lastSelectionBounds || this.state.selectionBounds;
      let containerStyle = {
        position: "absolute",
        top: "-1000px",
        left: "-1000px"
      };
      // let containerStyle = { position: "absolute", top: "0px", left: "0px" };

      if (this.state.selectionBounds && this.state.selectionBounds.ready) {
        this.lastSelectionBounds = this.state.selectionBounds;
      }

      let top = 0;
      let left = 0;

      if (!this.isMobile && bounds.ready) {
        left = bounds.x + bounds.width / 2 - this.toolbarRect.width / 2;
        top = bounds.y;
        // top = bounds.y - this.toolbarRect.height;

        // // force within screen
        let sw = window.screen.availWidth * 0.85;
        let sy = window.scrollY;
        // let tw = this.toolbarRect.width * 1.25;
        // if (left + tw >= sw) {
        //   left = sw - tw;
        // } else if (left < 40) {
        //   left = 40;
        // }
        if (top - sy < 0) {
          top = bounds.y + bounds.height + 10;
        }

        // left -= this.toolbarRect.offsetX;
        // top -= this.toolbarRect.offsetY;
      }

      let toolbarStyle = {
        // border: '2px solid blue',
        // position: "absolute",
        // top: top + "px",
        // left: left + "px"
      };

      Object.assign(containerStyle, {
        position: "absolute",
        top: `${top}px`,
        left: `${left}px`,
        // border: '2px solid red',
        // minHeight: '50px',
        transition:
          bounds.ready && this.toolbarRect.ready ? "opacity 500ms" : "",
        opacity: bounds.ready && this.toolbarRect.ready ? 1 : 0
      });

      if (this.isMobile) {
        containerStyle = {
          position: "fixed",
          bottom: "12px",
          width: null,
          height: null,
          margin: "0 auto", /* Will not center vertically and won't work in IE6/7. */
          left: "0px",
          right: "0px",
          display: 'none'
        };

        // if(this.currentButtons.length > 0) {
          containerStyle.display = 'block';
        // }
        toolbarStyle = { position: "relative", top: "0px", left: "0px" };
      }

      // let showComments = (ui == 'comments');
      // let uiState = ui + buttons.length + (showComments ? 1 : 0);
      // if (uiState != state.ui && bounds.ready) {
      //     this.setState({ui:uiState});
      //     this.redraw();
      // }

      // return { opacity: 1, border: '2px solid red' }
      return {
        container: [{ "z-index": 999 }, containerStyle],
        toolbar: toolbarStyle
      };
    },

    compute() {
      let uiElement = this.$refs["annot8-toolbar-inner"] || {};
      //document.querySelector('.annot8-toolbar-inner');

      let rect = {
        offsetX: 0,
        offsetY: 0,
        height: uiElement.offsetHeight + 10,
        width: uiElement.offsetWidth,
        ready: false
      };
      if (rect.width < 200) rect.width = 200;
      this.setState({ toolbarRect: rect });
      this.timeoutId = setTimeout(() => {
        let uiContainerElm = this.$refs["annot8-toolbar-container"] || {};
        if (!uiContainerElm.getBoundingClientRect) {
          return;
        }
        let offsetRect = uiContainerElm.getBoundingClientRect();
        let rect = this.toolbarRect;
        rect.ready = true;
        rect.offsetX = (offsetRect.x || offsetRect.left) + window.scrollX;
        rect.offsetY = (offsetRect.y || offsetRect.top) + window.scrollY;
        this.setState({ toolbarRect: rect });
      }, 10);
    },

    setState(state) {
      Object.keys(state).forEach(k => {
        this.state[k] = state[k];
      });
    }
  },

  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },

  mounted() {
    try {
      var navigator = window.navigator;
      this.isMobile =
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i);
      if (!this.isMobile) {
        this.isMobile =
          document.querySelector("html").offsetWidth < 600
            ? "smallScreen"
            : null;
      } else {
        this.mobile = true;
      }
    } catch (e) {
      // what are we then?
    }

    this.isMobile = true; // todo fix scrolling first
    window.$ui = this;
  }
};
</script>
<style></style>
